import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  padding: 0.25rem;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  > div {\n    display: inline-block;\n    padding: 0;\n    margin: 0;\n    margin-top: 0.6rem;\n    &:first-child {\n      svg {\n        top: -3px;\n        left: -1px;\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 16px;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  font-size: ", ";\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), function (props) {
  return props.theme.typography.smallFontSize;
}, function (props) {
  return props.isDefaultBillingAddress || props.isDefaultShippingAddress ? "#F5F1F2" : "#F6F7F8";
});
export var HeaderContent = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.blackDeep;
});
export var FooterContent = styled.div(_templateObject3());
export var MenuItem = styled.div(_templateObject4());